<template>
  <v-col cols="12">
    <v-card text color="grey lighten-4" width="100%">
      <v-card-text>
        <v-col cols="12" md="6">
            <v-text-field
              prepend-icon="attach_file"
              single-line
              v-model="file.name"
              :label="label"
              :required="required"
              @click.native="onFocus"
              :disabled="disabled" ref="fileTextField"
            />
            <input
              type="file"
              :accept="accept"
              :multiple="false"
              :disabled="disabled"
              ref="fileInput"
              @change="onFileChange"
            />
        </v-col>
        <v-col cols="12">
          <strong class="ma-1">File format:</strong>
          <span>{{ file.extension }}</span>
        </v-col>
        <v-col cols="12" v-if="file.name">
          <strong class="ma-1">File name:</strong>
          <span>{{ file.name }}</span>
        </v-col>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
  import papaparse from 'papaparse'
  export default{
    props: {
      value: {
        type: [Array, String]
      },
      accept: {
        type: String,
        default: "*"
      },
      label: {
        type: String,
        default: "Please choose..."
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        file: {
          name: '',
          extension: '',
          type: '',
          size: ''
        },
        allowedTypes: ['text/csv']
      }
    },
    watch: {
      value (v) {
        this.file.name = v
      }
    },
    mounted () {
      this.file.name = this.value
    },

    methods: {
      getFormData (file) {
        const data = new FormData()
        data.append('data', file, file.name)
        return data
      },
      onFocus () {
        if (!this.disabled) {
          this.$refs.fileInput.click()
        }
      },
      onFileChange ($event) {
        const files = $event.target.files || $event.dataTransfer.files
        const form = this.getFormData(files[0])
        if (files) {
          if (files.length) {
            this.file.name = [...files].map(file => file.name).join('')
            this.file.extension = '.' + this.file.name.split('.')[1]
            this.file.type = [...files].map(file => file.type).join('')
            this.file.size = [...files].map(file => file.size).join('')
          } else {
            this.file.name = null
          }
        } else {
          this.file.name = $event.target.value.split('\\').pop()
        }
        if (!this.validation(this.file.type)) {
          this.$store.dispatch('showNotification', {
            type: 'warning',
            message: ['Wrong file extension']
          })
          this.file.name = ''
          this.file.extension = ''
          this.file.type = ''
          this.file.size = ''
          return false
        }
        papaparse.parse(files[0], {
          complete: (parsedFile) => {
            this.$emit('input', this.file, parsedFile)
            this.$emit('formData', form)
          }
        })
      },
      validation (fileType) {
        if (!this.allowedTypes.find(type => type === fileType)) {
          this.$store.dispatch('showNotification', {
            type: 'warning',
            message: [`Next file types allowed: csv`]
          })
          return false
        }
        return true
      }
    }
  }
</script>
